import { render, staticRenderFns } from "./AxaptaSalaryList.vue?vue&type=template&id=05610a3c"
import script from "./AxaptaSalaryList.js?vue&type=script&lang=js&external"
export * from "./AxaptaSalaryList.js?vue&type=script&lang=js&external"
import style0 from "./AxaptaSalaryList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports